/**
 * 旧版 WebView / 学习机浏览器识别
 *
 * 步步高、小度 P20 等学习机 WebView 多停留在 Chromium 76–86，
 * 不支持 CSS `inset`（需 87+）、`100dvh`（需 108+）等，会导致 Tailwind 定位类失效。
 */

/** @returns {number|null} Chromium 主版本号 */
export function getChromiumMajorVersion (ua = typeof navigator !== 'undefined' ? navigator.userAgent : '') {
  const match = String(ua).match(/Chrom(?:e|ium)\/(\d+)/)
  return match ? Number(match[1]) : null
}

/** UA 是否像学习机 / 教育平板内置浏览器 */
export function isLearningDeviceUa (ua = typeof navigator !== 'undefined' ? navigator.userAgent : '') {
  return /Dueros|DuerOS|DuerShow|XiaoDu|xiaodu|小度|XDH|P20|EEBBK|步步高|Readboy|读书郎|YouXue|优学|Seewo|希沃|IFLYTEK|科大讯飞|JZT|作业帮|LenovoTab|学习机|baiduboxapp|BaiduHD/i.test(String(ua))
}

function hasTouch () {
  if (typeof window === 'undefined') return false
  return 'ontouchstart' in window || (navigator.maxTouchPoints || 0) > 0
}

function getViewportMinSide () {
  if (typeof window === 'undefined') return 0
  const sides = [window.innerWidth, window.innerHeight].filter((n) => n > 0)
  return sides.length ? Math.min(...sides) : 0
}

/** Android 应用内 WebView（学习机内置浏览器常见 ; wv) 标识） */
export function isAndroidWebViewUa (ua = typeof navigator !== 'undefined' ? navigator.userAgent : '') {
  return /Android/i.test(ua) && /;\s*wv\)/i.test(ua)
}

/** 当前环境是否不支持 CSS inset 简写 */
export function lacksInsetSupport () {
  if (typeof CSS === 'undefined' || typeof CSS.supports !== 'function') return true
  return !CSS.supports('inset', '0px')
}

/**
 * 是否应按旧版 WebView 处理（登录页等禁用双栏/视频，使用兼容定位）
 * @returns {boolean}
 */
export function isLegacyWebView () {
  if (typeof window === 'undefined') return false

  const ua = navigator.userAgent || ''
  const chromeMajor = getChromiumMajorVersion(ua)

  if (chromeMajor != null && chromeMajor < 87) return true
  if (isLearningDeviceUa(ua)) return true
  if (lacksInsetSupport()) return true
  // 小度 P20 等学习机 WebView 常无品牌 UA，仅靠 Android wv + 触控大屏识别
  if (isAndroidWebViewUa(ua) && hasTouch() && getViewportMinSide() >= 600) return true

  return false
}
